import { useEffect, useState } from "react";
import AppRoutes from "./routes/routes";
import axios from "axios";
import FullScreenLoader from "./components/FullScreenLoader/FullScreenLoader";

export default function App() {
  const [bloqueado, setBloqueado] = useState(false);
  const [carregando, setCarregando] = useState(true);
  const timeZone = "America/Sao_Paulo";

  useEffect(() => {
    async function verificarData() {
      try {
        const res = await axios.get(
          "https://api.timezonedb.com/v2.1/get-time-zone",
          {
            params: {
              key: "9TBEASXHDR7M",
              format: "json",
              by: "zone",
              zone: timeZone,
            },
          }
        );

        const { formatted } = res.data;
        const agoraBrasiliaAPI = new Date(formatted.replace(" ", "T"));

        const anoAPI = agoraBrasiliaAPI.getFullYear();
        const mesAPI = agoraBrasiliaAPI.getMonth() + 1;

        const agoraCliente = new Date();
        const anoCliente = agoraCliente.getFullYear();
        const mesCliente = agoraCliente.getMonth() + 1;

        if (anoAPI !== anoCliente || mesAPI !== mesCliente) {
          setBloqueado(true);
        }
      } catch (err) {
        console.error("Erro ao verificar data:", err);
        setBloqueado(true); // Melhor bloquear em caso de falha
      } finally {
        setCarregando(false);
      }
    }

    verificarData();
  }, []);

  if (carregando) {
    return <div>
        <FullScreenLoader />
      </div>;
  }

  if (bloqueado) {
    return (
      <div
        style={{
          backgroundColor: "#111",
          color: "white",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          textAlign: "center",
          padding: 20,
          zIndex: 9999,
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
        }}
      >
        <h1>⚠️ Data incorreta</h1>
        <p>
          A data do seu dispositivo não corresponde ao MÊS real.
          <br />
          Por segurança, o sistema está bloqueado.
        </p>
        <p>Ajuste o calendário do sistema e atualize a página.</p>
      </div>
    );
  }

  
  return <AppRoutes />;
}
